import {Component, Input} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Address} from '@spartacus/core/src/model/address.model';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {PaymentMode} from '@app/model/order/dcp-order.model';
import {AddressUsage, CheckoutReviewOrderComponentTexts, DetailType} from '@app/model/order/dcp-order-entry.model';
import {DcpEntryGroup} from '@dcp/configurator';

@UntilDestroy()
@Component({
  selector: 'dcp-checkout-payments',
  templateUrl: './checkout-payments.component.html',
  styleUrl: './checkout-payments.component.scss'
})
export class CheckoutPaymentsComponent {
  @Input() providerContract: DcpEntryGroup;

  @Input() set entry(entry: OrderEntry) {
    this.paymentAddresses = entry?.addresses
      .filter((address) => this.addressType.includes(address.addressUsage as AddressUsage))
      .sort(
        (a, b) =>
          this.addressesOrder.indexOf(a.addressUsage) - this.addressesOrder.indexOf(b.addressUsage)
      );
    this.contactAddresses = entry?.addresses
      .filter((address) => this.contactType.includes(address.addressUsage as AddressUsage))
      .sort(
        (a, b) =>
          this.addressesOrder.indexOf(a.addressUsage) - this.addressesOrder.indexOf(b.addressUsage)
      );
  };

  @Input() componentTexts: CheckoutReviewOrderComponentTexts;
  @Input() paymentModes: PaymentMode[];
  @Input() expandAll: boolean = false;

  public paymentAddresses: Address[];
  public contactAddresses: Address[];

  protected readonly DetailType = DetailType;

  public addressType: AddressUsage[] = [
    // TODO: check id CUST_END will be ned in another place, then make conditional here
    // AddressUsage.END_CUST, AddressUsage.SOLD_TO, AddressUsage.BILL_TO, AddressUsage.SHIP_TO
    AddressUsage.SOLD_TO, AddressUsage.BILL_TO, AddressUsage.SHIP_TO
  ]

  public contactType: AddressUsage[] = [
    AddressUsage.MAIN_CONTACT, AddressUsage.IT_CONTACT
  ]
  public addressesOrder: string[] = [...this.addressType, ...this.contactType];

}
